<div style="font-size: 10px" class="container tablecontainer">
    <div class="row">
  
      <div class="search">
        <label for="search">Search for User Advertisment</label>
  
        <div class="md-form">
          <input style="border: 1px solid #5d2041;"
            type="text"
            [(ngModel)]="searchText"
            class="form-control"
            id="search"
            mdbInput
          />
        </div>
      </div>
    </div>
  
    <table mdbTable #eventsTable="mdbTable" class="z-depth-1">
      <thead style="background-color: #5d2041; color: white;">
        <tr>
          <th
            *ngFor="let head of headElements; let i = index"
            aria-controls="tableSortExample" 
            scope="col" 
            [mdbTableSort]="adsList" 
            [sortBy]="headElements[i]"
          >
            {{head | titlecase}}
          </th>
          
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let el of adsList; let i = index">
          <th *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex"
            scope="row">{{el.name}}</th>
            
          <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">
            <img style="width: 150px;" src="{{'https://events.globalistic.tech/'+ el.image}}" /></td>
          <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{el.description}}</td>
          <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{el.link}}</td>
          <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{el.ad_package[0].package[0].name}}</td>
          <!-- <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{el.country}}</td> -->
          <!-- <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{el.status}}</td> -->
          <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">
            <button mat-flat-button color="primary" (click)="showCancellation(el.id)"> Delete</button>
          </td>
          
  
        </tr>
          <td colspan="4">
            <mdb-table-pagination [tableEl]="eventsTable" [searchDataSource]="adsList"></mdb-table-pagination>
          </td>
      </tbody>
    </table>
  </div>

   <!-- Cancellation Reason Modal -->
  
 <div [style.display]="cancellationReason ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1" role="dialog"
 aria-labelledby="myModalLabel" aria-hidden="true">
 <div class="modal-dialog">
   <div class="modal-content">
     <div class="modal-header">
       <h4 class="modal-title" id="myModalLabel">Delete Ad</h4>
       <i style="cursor: pointer;" style="transform: scale(2);" data-dismiss="modal" (click)="hideCancellation()"
         class="material-icons">highlight_off</i>

     </div>
     <div style="display: inline-block;">

       <div class="modal-body">
        
         <mat-label>Are you sure you want to delete this ad?</mat-label>

         <button  (click)="deleteAdUser()" class="confirmcancellation">Confirm</button>
       </div>
       <div class="modal-footer">

       </div>
     </div>
   </div>
 </div>
</div>